<app-modal-container
  (changeStep)="onChangeStep($event)"
  [steps]="steps"
  (showAndamentoCertificacaoClick)="onShowAndamentoCertificacao()"
  [unidadeProdutiva]="unidadeProdutiva"
  (onUpdate)="_inicializar()"
  [esconderAndamentoCertificacao]="esconderAndamentoCertificacao"
  (toggleModalStatus)="toggleModalStatus($event)"
  [perfilUsuario]="perfilUsuario"
  [loading]="loading"
>
  <ng-container *ngIf="modalAberto && !loadingVCP && !loadingCertificacao">
    <modal-convite
      #modalConvite
      *ngIf="activeStepLabel === 'Convite'"
      [unidadeProdutiva]="unidadeProdutiva"
      [safraId]="safraId"
    ></modal-convite>
    <modal-etapa-vcp
      *ngIf="activeStepLabel === 'VCP'"
      [status]="status"
      [unidadeProdutiva]="unidadeProdutiva"
      (concluirVCP)="onConcluirVCP()"
    >
    </modal-etapa-vcp>
    <modal-aceite-convite
      #modalAceiteConvite
      *ngIf="convidado"
      [unidadeProdutiva]="unidadeProdutiva"
    ></modal-aceite-convite>

    <app-modal-etapa-certificado-abr
      *ngIf="activeStepLabel === 'Certificado ABR'"
      [status]="statusCertificacao"
      (atualizacaoRealizada)="_inicializar()"
      [unidadeProdutiva]="unidadeProdutiva"
    >
    </app-modal-etapa-certificado-abr>
  </ng-container>
</app-modal-container>
